import { render, staticRenderFns } from "./OCAccordion.html?vue&type=template&id=23f58464&scoped=true&"
import script from "./OCAccordion.ts?vue&type=script&lang=ts&"
export * from "./OCAccordion.ts?vue&type=script&lang=ts&"
import style0 from "./OCAccordion.css?vue&type=style&index=0&id=23f58464&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23f58464",
  null
  
)

export default component.exports